<div class="bg-main">
  <div class="container">
    <div class="row">
      @if (menuItems()) {
      <div class="col-12">
        <div class="navbar navbar-expand">
          <div class="jasper d-flex align-items-center">
            <a href="https://connect.securechoicelending.com/apps/jasper" target="_blank">
              <img src="/assets/images/jasper-logo.png" alt="Jasper AI" />
            </a>
            <div class="text-white fs-14px ml-2">
              HELLO! I'M YOUR SCL AI, JASPER. <br /> HOW CAN I ASSIST YOU?
            </div>
          </div>
          <!--<div class="expand-jasper-menu" *ngIf="showJasperMenu">
            <div class="d-flex align-items-center">
              <div class="arrow-left pointer" *ngIf="showJasperMenu"></div>
              <ul class="d-flex text-white py-4 pl-0 mb-0">
                @for(mi of jasperMenuItems; track mi) {
                <li class="px-4">
                  <a [routerLink]="mi.navCommands" class="text-white" (click)="onJasperItemClick(mi)">
                    <div class="d-flex align-items-center">
                      <img src="/assets/images/jasper2.png" alt="Jasper AI" />
                      <div class="text-white ml-2">{{mi.name}}</div>
                    </div>
                  </a>
                  <p class="m-0 pt-3">{{mi.description}}</p>
                </li>
                }
              </ul>
            </div>
          </div>-->
          <div class="collapse navbar-collapse justify-content-end">
            <ul class="navbar-nav text-white justify-content-end" style="min-height: 51px;">
              @for (item of menuItems(); track item.id) {
              <li [routerLinkActive]="['link-active']">
                @if (!item.externalLink) {
                <a class="nav-link text-white" [routerLink]="item.navCommands">
                  <img [src]="item.imgUrl" [alt]="item.name" width="35" height="35">
                  {{item.name | uppercase}}
                </a>
                } @else {
                <a class="nav-link text-white" [href]="item.externalLink" target="_blank">
                  <img [src]="item.imgUrl" [alt]="item.name" width="35" height="35">
                  {{item.name | uppercase}}
                </a>
                }
              </li>
              }
            </ul>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
